import { useEffect } from 'react';

import useUiTranslation from 'src/hooks/useUiTranslation';

const useCheckClientVersion = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const platform = urlParams.get('platform');
  const clientVersion = urlParams.get('client');

  const { tPages } = useUiTranslation();

  useEffect(() => {
    const CLIENT_VERSION = ['1.0.0', '1.0.1'];

    if (platform && clientVersion) {
      console.log(`Client platform: ${platform} version: ${clientVersion}`);
    }

    if (clientVersion && !CLIENT_VERSION.includes(clientVersion)) {
      console.log(
        `Client version mismatch: current=${clientVersion} required=${CLIENT_VERSION}`,
      );

      window.alert(`
                                                    ⚠️ ${tPages('checkClientVersion.title')}

${tPages('checkClientVersion.outdatedVersion')}

${tPages('checkClientVersion.updatePrompt', { CLIENT_VERSION: CLIENT_VERSION.at(-1) })}

${tPages('checkClientVersion.downloadInfo')} https://download.optainhealth.com
      `);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientVersion, platform]);
};

export default useCheckClientVersion;
